import apiClient from './apiClient';

export const dashboardService = {
  getStats: async () => {
    const response = await apiClient.get('stats/dashboard/');
    return response.data;
  },
  getMonitoringResultDetail: async (resultId) => {
    const response = await apiClient.get(`monitoring/result/${resultId}/`);
    return response.data;
  },
  deleteMonitoringResult: async (resultId) => {
    const response = await apiClient.delete(`monitoring/result/${resultId}/`);
    return response.data;
  },
};

export const lookupService = {
  getAll: async () => {
    const response = await apiClient.get('lookups/');
    return response.data;
  },
};

export const clientiService = {
  list: async () => {
    const response = await apiClient.get('data/clienti/');
    return response.data;
  },
  create: async (payload) => {
    const response = await apiClient.post('data/clienti/', payload);
    return response.data;
  },
  update: async (id, payload) => {
    const response = await apiClient.put(`data/clienti/${id}/`, payload);
    return response.data;
  },
  remove: async (id) => {
    const response = await apiClient.delete(`data/clienti/${id}/`);
    return response.data;
  },
};

export const contracteService = {
  list: async () => {
    const response = await apiClient.get('data/contracte/');
    return response.data;
  },
  create: async (payload) => {
    const response = await apiClient.post('data/contracte/', payload);
    return response.data;
  },
  update: async (id, payload) => {
    const response = await apiClient.put(`data/contracte/${id}/`, payload);
    return response.data;
  },
  remove: async (id) => {
    const response = await apiClient.delete(`data/contracte/${id}/`);
    return response.data;
  },
};

export const monitorizareService = {
  list: async () => {
    const response = await apiClient.get('data/monitorizare/');
    return response.data;
  },
  create: async (payload) => {
    const response = await apiClient.post('data/monitorizare/', payload);
    return response.data;
  },
  update: async (id, payload) => {
    const response = await apiClient.put(`data/monitorizare/${id}/`, payload);
    return response.data;
  },
  remove: async (id) => {
    const response = await apiClient.delete(`data/monitorizare/${id}/`);
    return response.data;
  },
  importExcel: async (formData) => {
    // Content-Type must be set to undefined so axios auto-sets multipart/form-data with boundary.
    const response = await apiClient.post('data/monitorizare/import-excel/', formData, {
      headers: { 'Content-Type': undefined },
    });
    return response.data;
  },
};

export const monitoringService = {
  getOptions: async () => {
    const response = await apiClient.get('monitoring/options/');
    return response.data;
  },
  run: async (payload) => {
    const response = await apiClient.post('monitoring/run/', payload);
    return response.data;
  },
  runStart: async (payload) => {
    const response = await apiClient.post('monitoring/run/start/', payload);
    return response.data;
  },
  runStatus: async (jobId) => {
    const response = await apiClient.get(`monitoring/run/status/${jobId}/`);
    return response.data;
  },
  sendEmail: async (resultId) => {
    const response = await apiClient.post(`monitoring/result/${resultId}/send-email/`);
    return response.data;
  },
  retryKeyword: async (resultId, keyword) => {
    const response = await apiClient.post(`monitoring/result/${resultId}/retry-keyword/`, { keyword });
    return response.data;
  },
};
